/**
 * Centralized field descriptions for notification configuration fields.
 *
 * These descriptions are used as tooltip/info text across the platform —
 * both on single notification details and A/B test details summary views.
 * Any time a notification field needs a user-facing explanation, it should
 * be sourced from this file so the copy stays consistent.
 */

import React from 'react'

export const NOTIFICATION_FIELD_DESCRIPTIONS = {
    /** General section */
    status:
        'The current delivery status of this notification.',
    channels:
        'The platform channels this notification targets (Web, Native Apple, Native Android).',

    /** Delivery section */
    deliveryDateRange:
        'The window between the earliest scheduled send time and the latest expiry (send time + TTL).',
    deliveryStrategy:
        'How the notification is delivered — immediately, at a scheduled time, or in the subscriber\'s local timezone.',
    silentDelivery:
        'When enabled, the notification is delivered without triggering a sound or vibration on the device.',
    requiresInteraction:
        'When enabled, the notification remains visible until the user interacts with it rather than auto-dismissing.',
    replacementBehavior: (
        <div>
            <p>How this notification interacts with others on the device:</p>
            <ul style={{ paddingLeft: 16, margin: '4px 0' }}>
                <li><strong>Stack</strong>: shows each notification separately</li>
                <li><strong>Replace All</strong>: closes any currently shown notifications before displaying this one</li>
                <li><strong>Replacement Group</strong>: notifications sharing the same key replace each other</li>
            </ul>
        </div>
    ),

    /** Targeting section */
    targetedAudiences:
        'The subscriber segments this notification is sent to.',
    excludedAudiences:
        'Subscriber segments explicitly excluded from receiving this notification.',

    /** Content section */
    contentSources:
        'How notification content was created — manually, via Page Analyzer, or with Pushly AI.',

    /** Test-specific fields */
    testType:
        'Whether this test varies content, delivery timing, or both across its variants.',
    totalVariants:
        'The number of notification variants in this test, plus a winner notification if one has been promoted.',
}
